import i18n, { type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";

import deCommon from "../locales/de/common.json";
import enCommon from "../locales/en-US/common.json";
import frCommon from "../locales/fr/common.json";
import itCommon from "../locales/it/common.json";
import esCommon from "../locales/es/common.json";
import ruCommon from "../locales/ru/common.json";
import { DEFAULT_LOCALE, FALLBACK_LOCALE, type LocaleTag } from "./locales";

const resources = {
  "en-US": { common: enCommon },
  fr: { common: frCommon },
  de: { common: deCommon },
  it: { common: itCommon },
  es: { common: esCommon },
  ru: { common: ruCommon },
} as const;

export function createI18n(initialLocale: LocaleTag = DEFAULT_LOCALE): I18nInstance {
  const instance = i18n.createInstance();
  void instance.use(initReactI18next).init({
    resources,
    lng: initialLocale,
    fallbackLng: FALLBACK_LOCALE,
    defaultNS: "common",
    ns: ["common"],
    keySeparator: false,
    interpolation: { escapeValue: false, prefix: "{", suffix: "}" },
    react: { useSuspense: false },
  });
  return instance;
}
